import React, { useState, useEffect, useCallback, useRef } from 'react';
import Header from './components/Header';
import NorthStar from './components/NorthStar';
import Sidebar from './components/Sidebar';
import TOMi8versions from './components/pages/TOMi8versions';
import Projects_relations from './components/pages/Projects_relations';
import Units_status from './components/pages/helpdesk/Units_status';
import { getProfile, close_session } from "./utils/services";
import logo from './assets/logo_solo.png';
import './App.css';
import {  useNavigate } from 'react-router-dom';
import Despachos from './components/pages/Despachos';
import Models_admin from './components/pages/Models_admin';
import Legacy from './components/pages/Legacy';
import SubsistemaTOMi from './components/pages/SubsistemaTOMi';
import Members_master from './components/pages/talento/Members_master';
import Project_admin from './components/pages/Project_admin';
import Dashboard from './components/pages/dashboard/Dashboard';
import AdminToolsDashboard from './components/pages/dashboard/AdminToolsDashboard';
import Stocks from './components/pages/talento/Stocks';
import Individual_stock from './components/pages/talento/Individual_stock';
import Premium_services from './components/pages/premium_services/Premium_services';
import Contractor_admin from './components/pages/premium_services/Contractor_admin';
import Channels from './components/pages/crm/Channels';
import Channel_panel from './components/pages/crm/Channel_panel';
import OpportunityPage from './components/pages/crm/OpportunityPage';
import Opportunities from './components/pages/crm/Opportunities';
import Transactions_by_user from './components/pages/talento/Transactions_by_user';
import Email_info from './components/pages/helpdesk/Email_info';
import Cases_report from './components/pages/helpdesk/Cases_report';
import SuscripcionesT8 from './components/pages/helpdesk/SuscripcionesT8';
import Awards from './components/pages/talento/Awards';
import StrategyPage from './components/pages/talento/StrategyPage';
import QRshorter from './components/pages/crm/QRshorter';
import StrategyList from './components/pages/talento/StrategyList';
import Tacticfollowup from './components/pages/talento/Tacticfollowup';
import { ListTodo, Award, Play, LogOut } from 'lucide-react';
import UserAvatar from './components/pages/dashboard/UserAvatar';
import PendingClassification from './components/pages/dashboard/PendingClassification';
import Task_progress from './components/pages/talento/Task_progress';
import Statistics from './components/pages/talento/Statistics';
import PinsLotes from './components/pages/pins/PinsLotes';
import PinsEstado from './components/pages/pins/PinsEstado';
import PinsLotesQA from './components/pages/pins/PinsLotesQA';
import PinsEstadoQA from './components/pages/pins/PinsEstadoQA';
import PinesCupones from './components/pages/pins/PinesCupones';
import PinesCuponesQA from './components/pages/pins/PinesCuponesQA';
import ContenidoExclusivoT8 from './components/pages/pins/ContenidoExclusivoT8';
import WorkshopsEditor from './components/pages/workshops/WorkshopsEditor';
import WorkshopsCertificates from './components/pages/workshops/WorkshopsCertificates';
import MassMessaging from './components/pages/MassMessaging';
import Instituciones from './components/pages/observatorio/Instituciones';
import Institucion_panel from './components/pages/observatorio/Institucion_panel';
import TOMi8ApiDocs from './components/pages/tomi8/TOMi8ApiDocs';
import Admin_panel from './components/pages/admin/Admin_panel';
import Admin_products from './components/pages/admin/Admin_products';
import Produccion from './components/pages/manufacturing/Produccion';
import ProduccionDetail from './components/pages/manufacturing/ProduccionDetail';
import { get_awards_count, get_current_cards, get_notifications, mark_notification_attended } from './utils/talent_services';


function App({page}) {
  const token = localStorage.getItem("token");
  const navigate = useNavigate();
  const [profilePicUrl, setProfilePicUrl] = useState(null);

  
  let [devices_management, setDevice_management] = useState(undefined);
  let [logistics, setlogistics] = useState(undefined);
  let [project_management, setproject_management] = useState(undefined);
  let [talent_metrics, settalent_metrics] = useState(undefined);
  let [user_admin, setuser_admin] = useState(undefined);
  let [accountant, setaccountant] = useState(undefined);
  let [helpdesk, sethelpdesk] = useState(undefined);
  let [crm, setcrm] = useState(undefined);
  let [pin_management, set_pin_management] = useState(undefined);
  let [workshops, setworkshops] = useState(undefined);
  let [tomi8api, setTomi8api] = useState(undefined);
  let [ies_management, seties_management] = useState(undefined);
  let [manufacturing, setmanufacturing] = useState(undefined);
  let [subscriptors_manager, setsubscriptors_manager] = useState(undefined);
  let [company_dashs, setcompany_dashs] = useState(undefined);
  let [usr_name, setusrname] = useState("");
  let [usr_id, setusrid] = useState("");
  let [member_trello_id, setmember_trello_id] = useState("");
  let [current_activity, setactivity] = useState("Dashboard");
  let [usr_type, setusr_type] = useState();
  const [imgLoadError, setImgLoadError] = useState(false);
  const potentialProfileUrl = `https://team.tomi.la/storage/profile`;
  // Debes construir la URL del servidor directamente:
const [cards, setCards] = useState([]);
const [cardsLoading, setCardsLoading] = useState(false);
  const [notifications, setNotifications] = useState([]);
const [showNotifications, setShowNotifications] = useState(false);
const [loadingNotifications, setLoadingNotifications] = useState(false);
const notificationMenuRef = useRef(null);
const [pendingClassificationAmount, setPendingClassificationAmount] = useState(0);
const [awardsCount, setAwardsCount] = useState(0);
/** Tareas en ejecución del usuario logueado (sincronizadas desde el mapa / Tacticfollowup; sin fetch propio). */
const [myRunningTasks, setMyRunningTasks] = useState([]);

  const syncMyRunningTasks = useCallback((tasks) => {
    if (!Array.isArray(tasks)) {
      setMyRunningTasks([]);
      return;
    }
    const seen = new Set();
    const next = [];
    for (const t of tasks) {
      if (!t) continue;
      const title = String(t.title ?? t.task_name ?? '').trim();
      if (!title) continue;
      const key = String(t.key ?? t.id ?? title);
      if (seen.has(key)) continue;
      seen.add(key);
      next.push({ key, title });
    }
    setMyRunningTasks(next.slice(0, 8));
  }, []);

  const patchMyRunningTask = useCallback(({ taskId, title, active, completed } = {}) => {
    const taskTitle = String(title || '').trim();
    const key = String(taskId != null && taskId !== '' ? taskId : taskTitle);
    if (!key) return;
    const isRunning = Boolean(active) && !Boolean(completed);
    setMyRunningTasks((prev) => {
      if (isRunning) {
        if (!taskTitle) return prev;
        const without = prev.filter((t) => t.key !== key && t.title !== taskTitle);
        return [...without, { key, title: taskTitle }].slice(0, 8);
      }
      return prev.filter((t) => t.key !== key && t.title !== taskTitle);
    });
  }, []);



  // Estado para controlar la visibilidad del sidebar
  const [isSidebarOpen, setSidebarOpen] = useState(window.innerWidth > 992);
  const [isSidebarCollapsed, setIsSidebarCollapsed] = useState(false);

  
  useEffect(() => {
   
    if (page !== ""){
      setactivity(page);
    }
  }, [page]); // Solo se vuelve a ejecutar si 'token' cambia

  useEffect(() => {
    if (current_activity !== 'Project_admin') {
      return;
    }

    // Al entrar a Project_admin:
    // - En desktop: ocultamos el sidebar (equivalente a click en hamburger).
    // - En móvil/tablet: cerramos el panel deslizable si estaba abierto.
    if (window.innerWidth >= 992) {
      setIsSidebarCollapsed(true);
    } else {
      setSidebarOpen(false);
    }
  }, [current_activity]);


  useEffect(() => {
    async function fetchProfile() {
     
      const profile = await getProfile(token);
      if (profile==="INVALID" ||  typeof profile !== 'object' ){
        localStorage.removeItem("token");
        navigate("/");
      }else{
        setusrid(profile[0].id);
        setusrname(profile[0].usr_name);
        setusr_type(profile[0].type);
        setDevice_management(profile[0].devices_management);
        setlogistics(profile[0].logistics);
        setproject_management(profile[0].project_management);
        settalent_metrics(profile[0].talent_metrics);
        setuser_admin(profile[0].user_admin);
        setaccountant(profile[0].accountant);
        setcrm(profile[0].crm);
        set_pin_management(profile[0].pin_management);
        setcompany_dashs(profile[0].company_dashs);
        sethelpdesk(profile[0].helpdesk);
        setmember_trello_id(profile[0].member_trello_id);
        setworkshops(profile[0].workshops);
        setTomi8api(profile[0].tomi8api);
        seties_management(profile[0].ies_management);
        setmanufacturing(profile[0].manufacturing);
        setsubscriptors_manager(profile[0].subscriptors_manager);

     }
    
   
    }

    fetchProfile();
     if (cards.length===0) fetch_get_current_cards();
  }, [token]); // Solo se vuelve a ejecutar si 'token' cambia

  const refreshNotifications = useCallback(async () => {
    if (!token) {
      setNotifications([]);
      return;
    }

    setLoadingNotifications(true);
    try {
      const response = await get_notifications(token);
      if (response === 'INVALID' || !Array.isArray(response)) {
        setNotifications([]);
      } else {
        setNotifications(response);
      }
    } catch (error) {
      console.error('Error al cargar notificaciones:', error);
      setNotifications([]);
    } finally {
      setLoadingNotifications(false);
    }
  }, [token]);

  const refreshAwardsCount = useCallback(async () => {
    if (!token || !usr_id) {
      setAwardsCount(0);
      return;
    }

    try {
      const response = await get_awards_count(token, usr_id);
      if (response === "INVALID") {
        localStorage.removeItem("token");
        navigate("/");
        return;
      }
      const total = response && response.total != null ? Number(response.total) : 0;
      setAwardsCount(Number.isFinite(total) && total > 0 ? total : 0);
    } catch (error) {
      console.error('Error al cargar conteo de reconocimientos:', error);
      setAwardsCount(0);
    }
  }, [token, usr_id, navigate]);

  useEffect(() => {
    if (!token) {
      setNotifications([]);
      return;
    }

    refreshNotifications();
    const intervalId = setInterval(refreshNotifications, 60000);

    return () => clearInterval(intervalId);
  }, [token, refreshNotifications]);

  useEffect(() => {
    refreshAwardsCount();
  }, [refreshAwardsCount]);

  useEffect(() => {
    if (!showNotifications) {
      return;
    }

    const handleOutsideClick = (event) => {
      if (notificationMenuRef.current && !notificationMenuRef.current.contains(event.target)) {
        setShowNotifications(false);
      }
    };

    document.addEventListener('mousedown', handleOutsideClick);
    return () => document.removeEventListener('mousedown', handleOutsideClick);
  }, [showNotifications]);

  const unattendedCount = notifications.reduce((count, notification) => {
    return count + (Number(notification.attended) === 0 ? 1 : 0);
  }, 0);

  const handleNotificationToggle = () => {
    const nextValue = !showNotifications;
    setShowNotifications(nextValue);
    if (nextValue) {
      refreshNotifications();
    }
  };

  const formatNotificationDate = (dateString) => {
    if (!dateString) {
      return '';
    }
    const date = new Date(dateString.replace(' ', 'T'));
    if (Number.isNaN(date.getTime())) {
      return dateString;
    }
    return date.toLocaleString();
  };

  const handleNotificationClick = (notification) => {
    const data = notification && notification.data && typeof notification.data === 'object' ? notification.data : {};
    const destination = data.click_action || '/';

    const proceedNavigation = () => {
      setShowNotifications(false);
      navigate(destination);
    };

    if (Number(notification.attended) === 1) {
      proceedNavigation();
      return;
    }

    mark_notification_attended(token, notification.id)
      .finally(() => {
        refreshNotifications();
        proceedNavigation();
      });
  };

  const toggleSidebar = () => {
    // En móvil/tablet abrimos/cerramos el panel deslizante.
    if (window.innerWidth <= 991.98) {
      setSidebarOpen(!isSidebarOpen);
      return;
    }
    // En escritorio colapsamos/expandimos el ancho del sidebar.
    setIsSidebarCollapsed((prev) => !prev);
  };
  


   async function fetch_get_current_cards() { //Cargo las tarjetas en ejecucion para usarlas en varias partes
              setCardsLoading(true);
              try {
                const currentCardslist_byKR = await get_current_cards(token);
                if (currentCardslist_byKR==="INVALID"){
                  localStorage.removeItem("token");
                  navigate("/");
                }else{
        
                    if (!Array.isArray(currentCardslist_byKR)) {
                      // Para usuarios sin permiso (ej. talent_metrics=0) el backend puede devolver "" o null
                      // en vez de un array. Evitamos que falle el forEach.
                      console.warn('[fetch_get_current_cards] get_current_cards no devolvió un array:', currentCardslist_byKR);
                      setCards([]);
                      return;
                    }

                    setCards([]);
                    currentCardslist_byKR.forEach(element => {
                        const krHead = {isKr:true, krid:element.id, krname: element.name };
        
                        setCards(prevCards => [...prevCards, krHead]);
        
                        const currentKr = element['cards'].map((celement, index) => {
                            return {isKr:false,
                                 krid: element.id, 
                                 kr_trello_id: celement.kr_trello_id ?? null,
                                 card_db_id: celement.card_db_id,
                                 cardid: celement.cardid, 
                                 cardname: celement.cardname, 
                                 shortUrl:celement.shortUrl, 
                                 members: celement.members, 
                                 desc:celement.desc, 
                                 card_status: celement.card_status,
                                 estado: celement.estado,
                                 index: index };
                          });
        
                  
                          setCards(prevCards => [...prevCards, ...currentKr]);
                    });
               }
              } catch (error) {
                console.error('[fetch_get_current_cards] error:', error);
                setCards([]);
              } finally {
                setCardsLoading(false);
              }
            }


  const Header = ({ usr_name, toggleSidebar, setactivity }) => (
<header className="app-header">
    {/* Botón para alternar la Sidebar (en móvil abre/cierra, en desktop colapsa) */}
    <button type="button" className="app-header__menu-btn" onClick={toggleSidebar} aria-label="Abrir menú">
        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" viewBox="0 0 16 16">
            <path fillRule="evenodd" d="M2.5 12a.5.5 0 0 1 .5-.5h10a.5.5 0 0 1 0 1H3a.5.5 0 0 1-.5-.5m0-4a.5.5 0 0 1 .5-.5h10a.5.5 0 0 1 0 1H3a.5.5 0 0 1-.5-.5m0-4a.5.5 0 0 1 .5-.5h10a.5.5 0 0 1 0 1H3a.5.5 0 0 1-.5-.5"/>
        </svg>
    </button>

    {/* Logo y Team como enlace al Dashboard */}
    <button
      type="button"
      className="app-header__brand"
      onClick={() => {
        navigate('/Dashboard');
        setactivity && setactivity('Dashboard');
      }}
      aria-label="Ir al Dashboard"
    >
      <img src={logo} alt="" className="app-header__logo" />
      <span className="app-header__title">Team</span>
    </button>

    {parseInt(usr_type) === 0 && (
      <div className="app-header__pending-classification">
        <PendingClassification totalExpenses={pendingClassificationAmount} compact />
      </div>
    )}

    {parseInt(usr_type) === 0 && myRunningTasks.length > 0 && (
      <div className="app-header__running-tasks" title={` ${myRunningTasks.map((t) => t.title).join(', ')}`}>
        <Play size={14} className="app-header__running-icon" aria-hidden />
        <span className="app-header__running-label"></span>
        <button
          type="button"
          className="app-header__running-names"
          onClick={() => {
            navigate('/tactic_followup');
            setactivity && setactivity('Tacticfollowup');
          }}
          aria-label={`Ir a Administrador de Tareas. En ejecución: ${myRunningTasks.map((t) => t.title).join(', ')}`}
        >
          {myRunningTasks.map((t) => t.title).join(', ')}
        </button>
      </div>
    )}

    {/* North Star de empresa — centrada en la barra, solo equipo TOMi */}
    {parseInt(usr_type) === 0 && <NorthStar token={token} />}

    {/* Contenedor de Acciones */}
    <div className="app-header__actions">
        {parseInt(usr_type) === 0 && (
          <button
            type="button"
            className="app-header__icon-btn"
            onClick={() => navigate('/tactic_followup')}
            aria-label="Ir a Administrador de Tareas"
          >
              <ListTodo size={18} />
          </button>
        )}
    

    </div>
</header>
);

  const cerrar_sesion = () => {
    async function fetchClose_session() {
      try {
        await close_session(token);
      } finally {
        localStorage.removeItem('token');
        navigate('/', { replace: true });
      }
    }
    fetchClose_session();
  };

  const sidebarUserMenu = (
    <div className="sidebar-modern__avatar-wrap position-relative" ref={notificationMenuRef}>
      <button
        type="button"
        className="sidebar-modern__avatar-btn"
        onClick={handleNotificationToggle}
        aria-label="Abrir menú de usuario"
      >
        <UserAvatar
          key={usr_id}
          usr_id={usr_id}
          usr_name={usr_name}
          size={26}
        />
        {unattendedCount > 0 && (
          <span className="sidebar-modern__avatar-badge">
            {unattendedCount > 9 ? '9+' : unattendedCount}
          </span>
        )}
      </button>

      {showNotifications && (
        <div className="sidebar-modern__notifications-dropdown">
          <div className="card shadow">
            {Number(talent_metrics) >= 1 && (
              <div className="list-group list-group-flush border-bottom">
                <button
                  type="button"
                  className="list-group-item list-group-item-action d-flex align-items-center gap-2 py-2"
                  onClick={(event) => {
                    event.stopPropagation();
                    setShowNotifications(false);
                    navigate('/awards');
                    setactivity && setactivity('Awards');
                  }}
                >
                  <Award size={16} className="text-secondary flex-shrink-0" aria-hidden />
                  <span className="flex-grow-1 text-start small fw-semibold">Reconocimiento Externo</span>
                  {awardsCount > 0 && (
                    <span className="app-header__menu-count-badge">
                      {awardsCount > 99 ? '99+' : awardsCount}
                    </span>
                  )}
                </button>
              </div>
            )}
            <div className="card-header d-flex justify-content-between align-items-center py-2">
              <span className="fw-semibold text-dark">Notificaciones</span>
              <button
                type="button"
                className="btn btn-link btn-sm text-decoration-none"
                onClick={(event) => {
                  event.stopPropagation();
                  refreshNotifications();
                }}
              >
                Actualizar
              </button>
            </div>
            <div
              className="list-group list-group-flush"
              style={{ maxHeight: '320px', overflowY: 'auto' }}
            >
              {loadingNotifications ? (
                <div className="list-group-item text-center text-muted small">
                  Cargando notificaciones...
                </div>
              ) : notifications.length === 0 ? (
                <div className="list-group-item text-center text-muted small">
                  Sin notificaciones recientes.
                </div>
              ) : (
                notifications.map((notification) => {
                  const isAttended = Number(notification.attended) === 1;

                  return (
                    <button
                      type="button"
                      key={notification.id}
                      className={`list-group-item list-group-item-action text-start ${
                        isAttended ? '' : 'bg-danger-subtle'
                      }`}
                      onClick={() => handleNotificationClick(notification)}
                    >
                      <div className={`fw-semibold small mb-1 ${isAttended ? 'text-muted' : 'text-dark'}`}>
                        {notification.title || 'Notificación'}
                      </div>
                      {notification.body && (
                        <div className={`small mb-1 ${isAttended ? 'text-muted' : ''}`}>
                          {notification.body.length > 120
                            ? `${notification.body.slice(0, 117)}...`
                            : notification.body}
                        </div>
                      )}
                      <div className={`d-flex justify-content-between align-items-center small ${isAttended ? 'text-muted' : 'text-secondary'}`}>
                        <span>{formatNotificationDate(notification.sent_at)}</span>
                        <span className="text-primary">Abrir</span>
                      </div>
                    </button>
                  );
                })
              )}
            </div>
            <div className="list-group list-group-flush border-top">
              <button
                type="button"
                className="list-group-item list-group-item-action d-flex align-items-center gap-2 py-2 sidebar-modern__logout-item"
                onClick={(event) => {
                  event.stopPropagation();
                  setShowNotifications(false);
                  cerrar_sesion();
                }}
              >
                <LogOut size={16} className="flex-shrink-0" aria-hidden />
                <span className="flex-grow-1 text-start small fw-semibold">Cerrar sesión</span>
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );

const getInitials = (fullName) => {
    // ... (Use the logic from step 1)
    if (!fullName) return '';
    const names = fullName.trim().split(/\s+/);
    if (names.length >= 2) {
        return (names[0][0] + names[names.length - 1][0]).toUpperCase();
    }
    return names[0][0].toUpperCase();
};
  return (
 
     <>

      <div className="app-container">
        <Header usr_name={usr_name} token={token} toggleSidebar={toggleSidebar} setactivity={setactivity} />
        
        <div className="main-layout">
          <div className={`sidebar-container ${isSidebarOpen ? 'is-open' : ''} ${isSidebarCollapsed ? 'is-collapsed' : ''}`}>
            <Sidebar
                setactivity={setactivity}
                devices_management={devices_management}
                logistics={logistics}
                project_management={project_management}
                talent_metrics={talent_metrics}
                user_admin={user_admin}
                accountant={accountant}
                helpdesk={helpdesk}
                crm={crm}
                company_dashs={company_dashs}
                usr_type={usr_type}
                pin_management={pin_management}
                workshops={workshops}
                tomi8api={tomi8api}
                ies_management={ies_management}
                manufacturing={manufacturing}
                subscriptors_manager={subscriptors_manager}
                current_activity={current_activity}
                isCollapsed={isSidebarCollapsed}
                userMenu={sidebarUserMenu}
            />
          </div>
          
          {/* Capa oscura que aparece detrás del menú en móvil */}
          <div className="content-overlay" onClick={toggleSidebar}></div>

          <main className="content-area">
        {current_activity === 'TOMi8versions' && devices_management && <TOMi8versions permission={devices_management} />}
        {current_activity === 'SubsistemaTOMi' && devices_management && <SubsistemaTOMi />}
        {current_activity === 'Projects_relations'  && project_management && <Projects_relations usr_id={usr_id} permission={project_management} usr_type={usr_type}/>}
        {current_activity === 'Units_status'  && project_management && <Units_status usr_id={usr_id} permission={project_management}/>}
        {current_activity === 'Despachos'  && <Despachos usr_id={usr_id}/>}
        {current_activity === 'Produccion' && manufacturing === undefined && (
          <div className="p-4 text-muted">Cargando permisos…</div>
        )}
        {current_activity === 'Produccion' && manufacturing !== undefined && String(manufacturing) === '0' && (
          <div className="p-4">
            <h4 className="mb-2">Sin acceso a Producción</h4>
            <p className="mb-3 text-muted">
              No tienes permiso para ver la sección de Producción. Si necesitas acceso, solicita el permiso <strong>manufacturing</strong> a un administrador.
            </p>
            <button type="button" className="btn btn-primary btn-sm" onClick={() => navigate('/Dashboard')}>
              Ir al Dashboard
            </button>
          </div>
        )}
        {current_activity === 'Produccion' && manufacturing && manufacturing !== '0' && (
          <Produccion usr_id={usr_id} permission={manufacturing} />
        )}
        {current_activity === 'ProduccionDetail' && manufacturing === undefined && (
          <div className="p-4 text-muted">Cargando permisos…</div>
        )}
        {current_activity === 'ProduccionDetail' && manufacturing !== undefined && String(manufacturing) === '0' && (
          <div className="p-4">
            <h4 className="mb-2">Sin acceso a Producción</h4>
            <p className="mb-3 text-muted">
              No tienes permiso para ver órdenes de manufactura. Si necesitas acceso, solicita el permiso <strong>manufacturing</strong> a un administrador.
            </p>
            <button type="button" className="btn btn-outline-secondary btn-sm me-2" onClick={() => navigate(-1)}>
              Volver
            </button>
            <button type="button" className="btn btn-primary btn-sm" onClick={() => navigate('/Dashboard')}>
              Ir al Dashboard
            </button>
          </div>
        )}
        {current_activity === 'ProduccionDetail' && manufacturing && manufacturing !== '0' && (
          <ProduccionDetail usr_id={usr_id} usr_name={usr_name} permission={manufacturing} />
        )}
        {current_activity === 'Models_Admin'  && devices_management && <Models_admin  usr_id={usr_id} permission={devices_management}/>}
        {current_activity === 'Legacy' && devices_management === '1' && (
          <Legacy permission={devices_management} />
        )}
        {current_activity === 'Members_master'  && talent_metrics &&<Members_master  usr_id={usr_id} permission={talent_metrics}/>}
        {current_activity === 'Project_admin'  && project_management && (
          <Project_admin usr_id={usr_id} permission={project_management} usr_type={usr_type} pin_management={pin_management} />
        )}
        {current_activity === 'Dashboard' && usr_type && (
          parseInt(usr_type) === 0 ? (
            <Dashboard
              self_cards={cards}
              member_trello_id={member_trello_id}
              usr_id={usr_id}
              usr_type={usr_type}
              onPendingClassificationChange={setPendingClassificationAmount}
              onMyRunningTasksChange={syncMyRunningTasks}
              onMyRunningTaskPatch={patchMyRunningTask}
            />
          ) : (
            <AdminToolsDashboard />
          )
        )}
        {current_activity === 'Expenses'  &&talent_metrics&& <Transactions_by_user  user_id={usr_id} permission={talent_metrics} permission_accountant={accountant} />}
        {current_activity === 'Stocks'  && <Stocks  usr_id={usr_id} permission={talent_metrics} />}
        {current_activity === 'Individual_stock' && usr_id && (  <Individual_stock usr_id={usr_id} permission={talent_metrics} />)}
        {current_activity === 'Premium_services' && usr_id && (  <Premium_services usr_id={usr_id} permission={talent_metrics} />)}
        {current_activity === 'Contractor'  && project_management && <Contractor_admin  usr_id={usr_id} permission={project_management} />}
        {current_activity === 'Channels'  && crm && <Channels  usr_id={usr_id} permission={crm} usr_type={usr_type}/>}
        {current_activity === 'Channel_panel'  && crm && <Channel_panel usr_type={usr_type}  usr_id={usr_id} permission={crm} />}
        {current_activity === 'OpportunityPage'  && crm && <OpportunityPage usr_type={usr_type}  usr_id={usr_id} permission={crm} cards={cards} />}
        {current_activity === 'Opportunities'  && crm && <Opportunities usr_type={usr_type} usr_name={usr_name}  usr_id={usr_id} permission={crm} />}
        {current_activity === 'Email_info'  && helpdesk && <Email_info usr_name={usr_name}  usr_id={usr_id} permission={helpdesk} usr_type={usr_type} subscriptors_manager={subscriptors_manager} />}
        {current_activity === 'Cases_report'  && project_management && <Cases_report  usr_id={usr_id} permission={project_management} />}
        {current_activity === 'SuscripcionesT8' && subscriptors_manager && String(subscriptors_manager) !== '0' && (
          <SuscripcionesT8 permission={subscriptors_manager} token={token} />
        )}
        {current_activity === 'Awards'  && talent_metrics && <Awards  usr_id={usr_id} permission={talent_metrics} />}
        {current_activity === 'Strategypage'  && talent_metrics && <StrategyPage usr_type={usr_type}  usr_id={usr_id} permission={talent_metrics} />}
        {current_activity === 'Qrshorter'  && crm && <QRshorter usr_type={usr_type}  usr_id={usr_id} permission={talent_metrics} />}
        {current_activity === 'Strategylist'  && talent_metrics && <StrategyList usr_type={usr_type}  usr_id={usr_id} permission={talent_metrics} />}
        {current_activity === 'Tacticfollowup' && parseInt(usr_type) === 0 && talent_metrics && (
          <Tacticfollowup
            cards={cards}
            cardsLoading={cardsLoading}
            token={token}
            usr_type={usr_type}
            usr_id={usr_id}
            permission={talent_metrics}
            crm={crm}
            onMyRunningTasksChange={syncMyRunningTasks}
            onMyRunningTaskPatch={patchMyRunningTask}
          />
        )}
        {current_activity === 'Task_progress'  && talent_metrics && <Task_progress self_cards={cards}  member_trello_id={member_trello_id} token={token} title="Goals a la vista" usr_type={usr_type}  usr_id={usr_id} permission={talent_metrics} />}
        {current_activity === 'Statistics'  && talent_metrics && (
          <Statistics
            cards={cards}
            token={token}
            usr_type={usr_type}
            usr_id={usr_id}
            permission={talent_metrics}
            onTaskStateChange={(detail) => {
              if (detail && typeof detail === 'object') patchMyRunningTask(detail);
            }}
          />
        )}
        
        {current_activity === 'PinsLotes'  && (Number(pin_management) === 1 || Number(pin_management) === 3) && (
          <PinsLotes usr_id={usr_id} permission={pin_management} token={token} />
        )}
        {current_activity === 'PinsEstado'  && pin_management && <PinsEstado usr_id={usr_id} permission={pin_management} token={token} />}
        {current_activity === 'PinsLotesQA' && Number(pin_management) === 3 && (
          <PinsLotesQA usr_id={usr_id} permission={pin_management} token={token} />
        )}
        {current_activity === 'PinsEstadoQA' && Number(pin_management) === 3 && (
          <PinsEstadoQA usr_id={usr_id} permission={pin_management} token={token} />
        )}
        {current_activity === 'PinesCupones' && Number(pin_management) >= 1 && (
          <PinesCupones usr_id={usr_id} permission={pin_management} token={token} />
        )}
        {current_activity === 'PinesCuponesQA' && Number(pin_management) === 3 && (
          <PinesCuponesQA usr_id={usr_id} permission={pin_management} token={token} />
        )}
        {current_activity === 'ContenidoExclusivoT8' && (Number(pin_management) === 1 || Number(pin_management) === 3) && (
          <ContenidoExclusivoT8 usr_id={usr_id} permission={pin_management} token={token} />
        )}
        {current_activity === 'WorkshopsEditor'  && workshops && <WorkshopsEditor usr_id={usr_id} permission={workshops} />}
        {current_activity === 'WorkshopsCertificates'  && workshops && <WorkshopsCertificates usr_id={usr_id} permission={workshops} />}
        {current_activity === 'MassMessaging' && project_management === '1' && <MassMessaging usr_id={usr_id} usr_name={usr_name} permission={project_management} />}
        {current_activity === 'Instituciones' && ies_management && String(ies_management) !== '0' && <Instituciones usr_id={usr_id} permission={ies_management} />}
        {current_activity === 'Institucion_panel' && ies_management && String(ies_management) !== '0' && <Institucion_panel usr_id={usr_id} permission={ies_management} />}
        {current_activity === 'TOMi8Api' && tomi8api === undefined && (
          <div className="p-4 text-muted">Cargando permisos…</div>
        )}
        {current_activity === 'TOMi8Api' && tomi8api !== undefined && Number(tomi8api) !== 1 && (
          <div className="p-4">
            <p className="mb-2">No tiene permiso para ver la documentación TOMi8 API.</p>
            <button type="button" className="btn btn-primary btn-sm" onClick={() => navigate('/Dashboard')}>
              Ir al Dashboard
            </button>
          </div>
        )}
        {current_activity === 'TOMi8Api' && Number(tomi8api) === 1 && <TOMi8ApiDocs />}

        {current_activity === 'Admin_panel' && user_admin === undefined && (
          <div className="p-4 text-muted">Cargando permisos…</div>
        )}
        {current_activity === 'Admin_panel' && user_admin !== undefined && user_admin === '0' && (
          <div className="p-4">
            <p className="mb-2">No tiene permiso para ver el Panel Admin.</p>
            <button type="button" className="btn btn-primary btn-sm" onClick={() => navigate('/Dashboard')}>
              Ir al Dashboard
            </button>
          </div>
        )}
        {current_activity === 'Admin_panel' && user_admin && user_admin !== '0' && <Admin_panel />}

        {current_activity === 'Admin_products' && user_admin === undefined && (
          <div className="p-4 text-muted">Cargando permisos…</div>
        )}
        {current_activity === 'Admin_products' && user_admin !== undefined && user_admin === '0' && (
          <div className="p-4">
            <p className="mb-2">No tiene permiso para ver Productos.</p>
            <button type="button" className="btn btn-primary btn-sm" onClick={() => navigate('/Dashboard')}>
              Ir al Dashboard
            </button>
          </div>
        )}
        {current_activity === 'Admin_products' && user_admin && user_admin !== '0' && <Admin_products />}

          </main>
        </div>
      </div>
    </>
  );
}





export default App;
